import layout from '@/views/layout/layout.vue'
const challengeList = r => require.ensure([], () => r(require('@/views/challengeManage/challenge/list.vue')), 'challengeManage-challenge-list')

const challengeManageChallenge = [
  {
    path: '/challengeManage/challenge',
    name: 'challengeManage-challenge',
    component: layout,
    redirect: '/challengeManage/challenge/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: challengeList,
        name: 'challengeManage-challenge-list',
        meta: {
          displayName: '签到入场查询',
          requireAuth: true
        }
      }
    ]
  }
]

export default challengeManageChallenge



// WEBPACK FOOTER //
// ./src/router/challengeManage/challenge.js